<template><section><h3>插件介绍</h3>
<p>Legend， 图例。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>orient</td>
<td>String</td>
<td><code v-pre>horizontal</code></td>
<td>布局方式，默认水平布局，可选值 <code v-pre>horizontal | vertical</code></td>
</tr>
<tr>
<td>align</td>
<td>Array</td>
<td><code v-pre>['left', 'top']</code></td>
<td>对齐方式，第 1 个值控制水平方向布局（可选值：<code v-pre>left | center | right</code>，也可设置为 <strong><em>数字</em></strong> 或 <strong><em>百分比</em></strong>），第 2 个值控制垂直方向布局（可选值：<code v-pre>top | center | bottom</code>， 也可设置为 <strong><em>数字</em></strong> 或 <strong><em>百分比</em></strong>）</td>
</tr>
<tr>
<td>formatter</td>
<td>Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>文本格式化函数</td>
</tr>
</tbody>
</table>
<h3>style</h3>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
legend.style(<span class="hljs-string">'text'</span>, { <span class="hljs-attr">color</span>: <span class="hljs-string">'#fff'</span> }
</code></pre>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>icon</td>
<td>面</td>
<td>图标样式</td>
</tr>
<tr>
<td>icon:hover</td>
<td>面</td>
<td>鼠标经过时图标样式</td>
</tr>
<tr>
<td>text</td>
<td>文本</td>
<td>文字样式</td>
</tr>
<tr>
<td>text:hover</td>
<td>文本</td>
<td>鼠标经过时文字样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>